import React, { useEffect, useState } from 'react';
import { JsonEditor as Editor } from 'jsoneditor-react';
import styled from 'styled-components';

import 'jsoneditor-react/es/editor.min.css';
import { listOfBatchOperations } from '../Operations/Operations';
import { Flexbox } from '@ibinder/common-frontend';
import {
  SearchableSingleSelect,
  TextArea,
  TextInput,
  ThemeButton,
  buttonTypes
} from '@ibinder/common-frontend';
import ace from 'brace';
import 'brace/mode/json';
import 'brace/theme/github';
import { useSubscribeToMessage } from '@ibinder/ui-common-hooks';
import { ADMIN_EVENT } from './consts';
import { InitiateAbortController } from './iBinderFetch';
import { CleanupImpersonation } from './ImpersonateUser';

const StyledFlexBox = styled(Flexbox)`
  width: 100%;
  align-items: end;
  > div {
    width: 100%;
  }
  button {
    margin-left: 0.5rem;
    height: 3rem;
  }
`;

export const BatchOperations = () => {
  const [activeIndex, setActiveIndex] = React.useState(undefined);
  const [theState, setState] = useState(null);
  const [jsonInput, setJsonInput] = useState({});
  const [theRequests, setTheRequests] = useState([]);

  const [tenantId, setTenantId] = React.useState('');
  const changeInputValue = (event: React.ChangeEvent<HTMLInputElement>) =>
    setTenantId(event.currentTarget.value);

  const data = listOfBatchOperations.map(({ sample, id, name }) => ({
    Key: id,
    Value: name
  }));

  const SelectedOperation = listOfBatchOperations.find(
    (p) => p.id === activeIndex
  );

  useEffect(() => {
    // Make sure to cleanup on new run
    CleanupImpersonation();
  }, []);

  const changeActiveItem = (index) => {
    setTheRequests([]);
    setActiveIndex(index);
    InitiateAbortController();
    setState(null);
    CleanupImpersonation();

    const op = listOfBatchOperations.find((p) => p.id === index);
    setJsonInput(op.sample);
  };

  useSubscribeToMessage(ADMIN_EVENT.FETCH_RESPONSE, (event) => {
    //@ts-ignore
    const { body, headers, status, url } = event.detail;

    setTheRequests((prev) => [...prev, { url, status }]);
  });

  useSubscribeToMessage(ADMIN_EVENT.EVENT_LOG, (event) => {
    setTheRequests((prev) => [...prev, { eventlog: event.detail }]);
  });

  const submit = activeIndex ? SelectedOperation.onSubmit({ tenantId }) : null;

  return (
    <>
      <StyledFlexBox>
        <SearchableSingleSelect
          label={'Select an operation'}
          dropdownText={'Select...'}
          activeKey={activeIndex}
          data={data}
          loading={false}
          changeActiveItem={changeActiveItem}
          searchPlaceholderText={'Search...'}
          required={false}
        />
        {activeIndex !== undefined && (
          <ThemeButton
            onClick={async () => {
              window.open(SelectedOperation.githubUrl);
            }}
            type={buttonTypes.Primary}
          >
            {`Code`}
          </ThemeButton>
        )}
      </StyledFlexBox>

      {localStorage.getItem('impersonation_token') && (
        <p>IMPERSONATION ACTIVE</p>
      )}
      {activeIndex !== undefined && (
        <>
          <p>{SelectedOperation.description}</p>
          <br />
          <h1>Argument</h1>
          <TextInput
            label={'Tenant Id'}
            changeValue={changeInputValue}
            value={tenantId}
          />
          <br />
          <Editor
            value={SelectedOperation.sample}
            onChange={(p) => setJsonInput(p)}
            ace={ace}
            theme="ace/theme/github"
            mode="code"
            statusBar={true}
            navigationBar={true}
            search={true}
            cursorStyle={'slim'}
          />
          <ThemeButton
            onClick={async () => {
              InitiateAbortController();
              setTheRequests([]);
              setState(null);
              await setState(await submit(jsonInput));
              CleanupImpersonation();
            }}
            type={buttonTypes.Primary}
          >
            {'Submit'}
          </ThemeButton>

          {theState && (
            <>
              <h1>Response</h1>

              <Editor
                value={theState ? JSON.parse(theState) : {}}
                onChange={(p) => console.log(p)}
                ace={ace}
                theme="ace/theme/github"
                mode="code"
                maxLines={100}
              />
            </>
          )}
          <br />
          <div>
            <h1>Requests</h1>
            {theRequests.map((request, id) => (
              <div key={`request-${id}`}>{JSON.stringify(request)}</div>
            ))}
          </div>
        </>
      )}
    </>
  );
};
